import { queryParams, type RouteQueryOptions, type RouteDefinition, applyUrlDefaults } from './../../../../../wayfinder'
/**
* @see \App\Http\Controllers\Invoice\ManageItemStockInvoiceController::__invoke
* @see app/Http/Controllers/Invoice/ManageItemStockInvoiceController.php
* @route '/api/invoicing/{invoice}/manage-items-stock'
*/
const ManageItemStockInvoiceController = (args: { invoice: string | number | { id: string | number } } | [invoice: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: ManageItemStockInvoiceController.url(args, options),
    method: 'post',
})

ManageItemStockInvoiceController.definition = {
    methods: ["post"],
    url: '/api/invoicing/{invoice}/manage-items-stock',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\Invoice\ManageItemStockInvoiceController::__invoke
* @see app/Http/Controllers/Invoice/ManageItemStockInvoiceController.php
* @route '/api/invoicing/{invoice}/manage-items-stock'
*/
ManageItemStockInvoiceController.url = (args: { invoice: string | number | { id: string | number } } | [invoice: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { invoice: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'id' in args) {
        args = { invoice: args.id }
    }

    if (Array.isArray(args)) {
        args = {
            invoice: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        invoice: typeof args.invoice === 'object'
        ? args.invoice.id
        : args.invoice,
    }

    return ManageItemStockInvoiceController.definition.url
            .replace('{invoice}', parsedArgs.invoice.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Invoice\ManageItemStockInvoiceController::__invoke
* @see app/Http/Controllers/Invoice/ManageItemStockInvoiceController.php
* @route '/api/invoicing/{invoice}/manage-items-stock'
*/
ManageItemStockInvoiceController.post = (args: { invoice: string | number | { id: string | number } } | [invoice: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: ManageItemStockInvoiceController.url(args, options),
    method: 'post',
})

export default ManageItemStockInvoiceController